import { useNavigate } from 'react-router-dom';
import { Files } from '../../../services/journey.service';
import BackButton from '../../../components/shared/BackButton';
import Tag from '../../../components/shared/Tag';
import FileItem from './FileItem';
import FileListPageViewModel from './viewModel';
import { PageContainer, PageHeader, YearTagsRow, FileListContainer, EmptyStateText } from './styled';
import { Typography } from '@mui/material';

interface Props {
  files: Files | null;
  category: string;
  backPath?: string;
}

export default function FileListPage({ files, category, backPath = '/meus-arquivos' }: Props) {
  const navigate = useNavigate();
  const { visibleFiles, years, selectedYear, setSelectedYear, pageTitle, isEmpty } = FileListPageViewModel({
    files,
    category
  });

  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate(backPath)} />
        <Typography variant="h3">{pageTitle}</Typography>
      </PageHeader>

      {years.length > 0 && (
        <YearTagsRow>
          {years.map(year => (
            <Tag key={year} text={year} active={selectedYear === year} onClick={() => setSelectedYear(year)} />
          ))}
        </YearTagsRow>
      )}

      <FileListContainer>
        {isEmpty ? (
          <EmptyStateText>Nenhum arquivo encontrado</EmptyStateText>
        ) : (
          visibleFiles.map(file => <FileItem key={file.id} file={file} />)
        )}
      </FileListContainer>
    </PageContainer>
  );
}
